import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import * as Actions from 'state/actions'
import MenuItem from 'general/components/MeuItem/MenuItem.component'

const mapStateToProps = state => {
  return {
    isLoaded: !!state.organisation.active,
    isSidebarMenuExpanded: state.ui.isSidebarMenuExpanded
  }
}

const mapDispatchToProps = dispatch => {
  return {
    onNavigate: route => () => dispatch(Actions.onNavigate(route))
  }
}

export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(MenuItem))
